import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    content: {
      padding: [22, 0],
      maxWidth: 360,
      margin: [0, "auto"],
      position: "relative",
      zIndex: 0,
      [theme.breakpoints.up("mobile")]: {
        maxWidth: 530,
        padding: [28, 64],
      },
      [theme.breakpoints.up("tablet")]: {
        maxWidth: 450,
        padding: [28, 22],
      },
    },
  }),
  { name: "Payment-Form" },
);
